<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
import { isMobile, storage } from "@/CommonDP/utils";
export default {
  data() {
    return {};
  },

  created() {
    const { q, i } = this.$route.query;
    if (i || q) {
      if (isMobile()) {
        storage.set("id", JSON.stringify(null));
        this.$router.replace({
          path: "/mainMg/share/appShare",
          query: { i: q || i }
        });
      } else {
        this.$router.replace({
          path: "/mainMg/share/webShare",
          query: { i: q || i }
        });
      }
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped></style>
